// The files feature (POC, ADR 0008): the organization's files, in the Resources group.
import { FolderUpIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";
import { routes } from "../context";

registerNav({
  id: "files",
  group: "resources",
  labelKey: "files.nav",
  icon: FolderUpIcon,
  to: () => routes.files(),
  order: 90,
});
